import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import * as _ from 'lodash';
import { FlatRateInitialDataModel } from '../../models';
import { flatAndRateSection } from '../../utils/index';

@Component({
  selector: 'spekwo-flat-rate-section',
  templateUrl: './flat-rate-section.component.html',
  styleUrls: ['./flat-rate-section.component.scss']
})
export class FlatRateSectionComponent implements OnInit {

  @Output() previousTotalCost = new EventEmitter<FlatRateInitialDataModel>();
  @Input() type: string;
  @Input() defaultValues;
  @Output() closePanle = new EventEmitter<boolean>();
  @Input() enableClose: boolean = true;

  nameValues = flatAndRateSection;
  panelOpenState = true;
  newAttribute: FlatRateInitialDataModel = {
    ni: null,
    cpi: null,
    totalCost: null
  }
  constructor() { }

  ngOnInit() {
    if (this.type == this.nameValues.editType) {
      this.assignInitialValues();
      this.onPanelOpenState(true);
    }
  }

  onPanelOpenState(state: boolean) {
    this.panelOpenState = state;
  }

  //Assigning initial values if component called from edit
  assignInitialValues() {

    if (this.defaultValues.ni != null && this.defaultValues.cpi != null && this.defaultValues.totalCost != null) {
      _.map(this.newAttribute, (value, key) => {
        this.newAttribute[key] = (this.defaultValues[key] != 0) ? this.defaultValues[key] : null;
      });
    }


  }

  //Calculating all cost values
  calculatedLaborCost() {
    this.newAttribute.totalCost = Number((Number(this.newAttribute.ni) * Number(this.newAttribute.cpi)).toFixed(2));
    this.previousTotalCost.emit(this.newAttribute);
  }

  close() {
    this.closePanle.emit(true);
  }


}



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/common/flat-rate-section/flat-rate-section.component.ts